import { type CreateBlockData } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import type {
  TextFieldSectionCreate,
  TextFieldSection,
} from '../../../../types/FormBuilder.types'
const i18n = i18nPlugin.global

export const createTextInputData = ({
  type,
  brandId,
}: CreateBlockData<TextFieldSection>): TextFieldSectionCreate => ({
  brandId,
  params: {
    label: i18n.t('form-builder.blocks.text-field'),
    placeholder: null,
    required: false,
    variant: null,
  },
  type,
})
